<template>
  <div class="statictics-overview grid">

    <div class='card statistic-card tracking-chart'>
      <div class='card--top-title'>{{$t('statistics.7days_activity')}}</div>
      <div class='card--content'>
        <tracking-chart :start-date="startDate" :end-date="endDate" :trackings="trackings"></tracking-chart>
      </div>
      <div class="card--footer">
        <div class="left">
          {{$t('statistics.actions')}}: {{stats.trackings_count}}
        </div>
        <div class="right">
          {{$t('statistics.average_per_day')}}: {{actionsPerDay(stats.trackings_count)}}
        </div>
      </div>
    </div>

    <div class='card statistic-card kits-stats'>
      <div class='card--top-title'>{{$t('statistics.kits')}}</div>
      <div class='card--content'>
        <div class="number">
          <p class="number--big">{{stats.trackings_bag_open_count}}x</p>
          <p class="number--subtext">
            {{$t('statistics.total_businesskit_opened')}}
          </p>
        </div>
      </div>
      <div class="card--footer">
        <div class="left">
          {{$t('statistics.businesskit_sent')}}: {{stats.sent_business_kits_count}}
        </div>
      </div>
    </div>

    <div class='card statistic-card coupons-stats'>
      <div class='card--top-title'>{{$t('statistics.coupons')}}</div>
      <div class='card--content'>
        <div class="number">
          <p class="number--big">{{stats.trackings_view_coupon_count}}</p>
          <p class="number--subtext">
            {{$t('statistics.coupons_viewed')}}
          </p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import TrackingChart from "@/components/helpers/Specific/TrackingChart"

export default {
  props: ['stats', 'trackings', 'startDate', 'endDate'],
  components: {TrackingChart},
  methods: {
    percentage(base,number){
      if(base == 0){
        return 0
      }
      return Math.floor((number/base) * 100)
    },
    baseOne(base,number){
      if(base == 0){
        base = 1
      }
      if(number == 0){
        number = 1
      }
      return Math.floor((number/base)*100)/100
    },
    actionsPerDay(actions){
      let difference = moment(this.endDate).diff(moment(this.startDate), 'days')
      return Math.floor((actions / difference)*100)/100
    }
  }

}
</script>
<style lang="scss" scoped>
.card{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 0 9px 0 rgba(189, 189, 189, 0.5);
  .card--top-title, .left, .right {
    color: $onyx-light;
  }
}

.lead-update-statistics{
  .statictics-overview{
    flex-direction: column;
  }
}
@include respond-to("small-up"){
  @include respond-to("medium"){
    .lead-update-statistics{
      .statictics-overview{
        flex-wrap: wrap;
      }
      .card.kits-stats{
        margin-left: 1px;
      }
    }
    .card.tracking-chart{
      flex-basis: 100%;
    }
  }
  .leads-chart .card--content,
  .tracking-chart .card--content{
    padding: 5px;
  }
}

.number--big{
  font-weight: 600;
  color: $onyx;
}
</style>



// WEBPACK FOOTER //
// StatisticsOverview.vue?4c3ce68e